import React, {Component} from "react";
import {observer} from "mobx-react";
import {Web3Store} from "../stores/web3Store";
import {RouteComponentProps, withRouter} from "react-router-dom";
import {
    IGetLicenseCollectionsResponse,
    ILicenseCollection,
    IMythServerResponse,
    INFTBrandItem
} from "../bean/ResponseBean";
import logger from "../logger";
import {RootStore} from "../stores/rootStore";
import {Button, Select} from "antd";
import {getRoutePath, MythRouteId} from "../router-config";
import "../styles/nftBrands.less";
import {MythPagination} from "../components/pagination";
import MythImage from "../components/MythImage";
import NoData from "../components/noData";
import {MythServerResultCode} from "../constant/CommonConstant";
import {PageLoader} from "../components/pageLoader";

interface IProps extends RouteComponentProps {
    web3Store: Web3Store;
    rootStore: RootStore;
}

interface IStates {
    brandList: INFTBrandItem[],
    pageNum: number,
    totalPage: number,
    totalNum: number,
    selectCollectionId: number,
    licenseCollections: ILicenseCollection[],
    loading: boolean

}

@observer
class NFTBrands extends Component<IProps, IStates> {
    private pageSize: number = 16;

    constructor(props: IProps, state: IStates) {
        super(props);
        this.state = {
            brandList: [],
            pageNum: 1,
            totalPage: 0,
            totalNum: 0,
            selectCollectionId: 0,
            licenseCollections: [],
            loading: true
        }
    }

    componentDidMount(): void {
        this.getAllBrands().then(value => {
            this.getLicenseCollections();
        });
    }

    getAllBrands = async () => {
        const {web3Store} = this.props;
        const {selectCollectionId, pageNum} = this.state;
        try {
            if (web3Store.mythServerApi) {
                web3Store.mythServerApi.getNFTBrands(selectCollectionId, pageNum, this.pageSize).then(response => {
                    if (response) {
                        this.setState({
                            brandList: response.resultValue.dataList,
                            pageNum: response.resultValue.pageNum,
                            totalPage: response.resultValue.totalPage,
                            totalNum: response.resultValue.totalNum,
                            loading: false
                        });
                    }
                })
            }
        } catch (ex: any) {
            logger.error(ex);
        }
    };

    getLicenseCollections = async () => {
        const {web3Store} = this.props;
        try {
            if (web3Store.mythServerApi) {
                const result: IMythServerResponse<IGetLicenseCollectionsResponse> = await web3Store.mythServerApi.getLicenseCollections();
                if (result.resultCode === MythServerResultCode.SUCCESS) {
                    const data = result.resultValue;
                    if (data) {
                        this.setState({
                            licenseCollections: data.licenseCollections
                        });
                    }
                }
            }
        } catch (e) {
            logger.error(e);
        }
    };

    onChangePage = (pageNo: number) => {
        this.setState({pageNum: pageNo}, () => this.getAllBrands());
    };

    onClickIPItem = (item: INFTBrandItem) => {
        this.props.history.push({
            pathname: getRoutePath(MythRouteId.BrandInfo),
            state: {brandId: item.id}
        });
    };

    onSelectBrand = (collectionId: number) => {
        this.setState({
            loading: true,
            selectCollectionId: collectionId,
            pageNum: 1
        }, () => {
            this.getAllBrands();
        })
    };

    onClickSubmit = (event: any) => {
        window.open("https://www.google.com");
    };

    render() {
        const {loading, licenseCollections} = this.state;
        const {Option} = Select;

        return <div className="brand-list-page-container">
            <div className="title-container flex-row space-between">
                <div><span className="list-title">Brand list</span> <Button className="myth-button"
                                                                            onClick={this.onClickSubmit}>Submit
                    Brand</Button></div>
                <Select onSelect={this.onSelectBrand} className="myth-select" defaultValue={0}>
                    <Option value={0} key="all">All Brands</Option>
                    {licenseCollections.map((item, index) => (
                        <Option value={item.id} key={index}><img src={item.logo} alt=""
                                                                 className="option-image"/>{item.name}</Option>
                    ))}
                </Select>
            </div>
            {loading ? this.renderLoading() : this.renderList()}
        </div>
    }


    renderLoading = () => {
        return <PageLoader marginTop={1}></PageLoader>;
    };

    private renderList() {
        const {brandList, pageNum, totalPage, totalNum} = this.state;
        return <>
            {brandList.length > 0 ?
                <div className="brand-list flex-row">
                    {brandList.map((item, index) => (
                        <div className="list-item" key={'brand-' + index} onClick={event => {
                            this.onClickIPItem(item)
                        }}>
                            <div className="img-container">
                                <MythImage className="item-img"
                                           src={item.logo}
                                           alt=""/>
                                {
                                    item.brandCollections && item.brandCollections.length > 0 ?
                                        <div className="collection-info">
                                            <span><MythImage src={item.brandCollections[0].collectionLogo}
                                                             alt=""/>{item.brandCollections[0].collectionName}
                                            </span>
                                        </div> : ""
                                }
                            </div>
                            <div className="item-name text-center">{item.name}</div>
                            <div className="item-type text-center">{item.productType}</div>
                        </div>
                    ))}
                </div> : <NoData/>}
            <MythPagination totalPage={totalPage} total={totalNum} showTotal={true}
                            currentPage={pageNum} pageSize={this.pageSize}
                            onChange={(pageNo: number) => this.onChangePage(pageNo)}/>
        </>;
    }
}

export default withRouter(NFTBrands);
